import { createSlice, SerializedError } from '@reduxjs/toolkit';

import { updateCustomer } from './thunks';

type UpdateCustomerState = {
  loading: boolean;
  error: SerializedError | null;
  requestId: string | null;
  savedAt: number | null;
};

type CustomersState = {
  updateCustomer: UpdateCustomerState;
};

const initialState: CustomersState = {
  updateCustomer: {
    loading: false,
    error: null,
    requestId: null,
    savedAt: null,
  },
};

const slice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    resetUpdateCustomer(state) {
      state.updateCustomer = { ...initialState.updateCustomer };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateCustomer.pending, (state, action) => {
      state.updateCustomer.loading = true;
      state.updateCustomer.error = null;
      state.updateCustomer.requestId = action.meta.requestId;
      state.updateCustomer.savedAt = null;
    });
    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      if (state.updateCustomer.requestId !== action.meta.requestId) {
        return;
      }
      state.updateCustomer.loading = false;
      state.updateCustomer.error = null;
      state.updateCustomer.savedAt = Date.now();
    });
    builder.addCase(updateCustomer.rejected, (state, action) => {
      if (state.updateCustomer.requestId !== action.meta.requestId) {
        return;
      }
      state.updateCustomer.loading = false;
      state.updateCustomer.error = action.error;
    });
  },
});

export const { resetUpdateCustomer } = slice.actions;

export default slice.reducer;
